module.exports = __webpack_public_path__ + "img/budget3.3719b68e.svg";